export default __webpack_public_path__ + "static/media/landing_dao_testitem.841bc36c.svg";